import { Typography } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useSelector } from 'react-redux';
import { selectCurrentVenue } from '../../redux/slices/currentUserSlice';
import { getVenueTimezone } from '../../utils/venueTimeFormatters';
import dayjs from '../../utils/dayjsConfig';
import { CustomDateTimePicker, CustomTimePicker, ItemBox } from './DateTimePickerWrapper.styles';

const DateTimePickerWrapper = ({
  label,
  value,
  open,
  onOpen,
  onClose,
  onChange,
  disabled,
  size = 'small',
  pickerType = 'time',
}) => {
  const currentVenue = useSelector(selectCurrentVenue);
  const venueTimezone = getVenueTimezone(currentVenue);

  const isDate = pickerType === 'date';
  const PickerComponent = isDate ? CustomDateTimePicker : CustomTimePicker;

  // Convert UTC time to venue timezone for display
  const getVenueDisplayTime = (utcTime) => {
    if (!utcTime) return null;
    // Ensure input is interpreted as UTC, then convert to venue timezone
    return dayjs.utc(utcTime).tz(venueTimezone);
  };

  // Convert venue time back to UTC for storage
  const getUTCTime = (venueTime) => {
    if (!venueTime) return null;
    // Convert venue time back to UTC
    return dayjs(venueTime).utc().toDate();
  };

  const handleTimeChange = (newTime) => {
    if (disabled) return;
    // Convert the selected venue time back to UTC for storage
    const utcTime = getUTCTime(newTime);
    onChange(utcTime);
  };

  return (
    <ItemBox>
      <Typography variant="bodyRegular">{label}</Typography>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <PickerComponent
          value={getVenueDisplayTime(value)}
          timezone={venueTimezone}
          open={open}
          size={size}
          onOpen={onOpen}
          onClose={onClose}
          onChange={handleTimeChange}
          ampm={!isDate}
          format={isDate ? 'MM/DD/YYYY' : 'h:mm a'}
          views={isDate ? ['year', 'month', 'day'] : undefined}
          slotProps={{
            textField: {
              onClick: disabled ? null : onOpen,
              sx: {
                opacity: disabled ? 0.5 : 1,
                cursor: disabled ? 'not-allowed' : 'pointer',
                '& .MuiInputBase-input': {
                  cursor: disabled ? 'not-allowed' : 'pointer',
                },
              },
            },
          }}
          disableTimeSelection={isDate}
        />
      </LocalizationProvider>
    </ItemBox>
  );
};

export default DateTimePickerWrapper;
